'use strict';
const DebugLogger = require('../DebugLogger')

module.exports = /* @ngInject */ function () {

	let eventSource;

	const IDS = {
		TASK_COUNT: 'TaskCount',
        ORDER_CHANGES: 'OrderStatusUpdateSseMessage'
	}

	const SSE_MESSAGE_TYPES = {
		PING: 'PING',
		MESSAGE: 'MESSAGE',
	}

	/**
	 * connect to a sse (server send event) endpoint and dispatch events on incoming messages.
	 * To listen to the dispatched events of a specific sse endpoint a listener can be registered as follows:
	 *
	 * window.addEventListener(<sse id from sseService.IDS>, (event)=>{
	 *     const sseData = event.detail;
	 *     // do stuff
	 * })
	 *
	 */
	function connect(apiUrl, accessToken) {
        const url = `${apiUrl}/sse/emitter`;
		eventSource = new EventSourcePolyfill.EventSourcePolyfill(url, {
			headers: {
				Authorization: `Bearer ${accessToken}`,
			},
		});
		DebugLogger.info(`AngularJs SSE`, 'connected');

		eventSource.onerror = (error) => {
            DebugLogger.info(`AngularJs SSE - error`, error);
			if (error.error) {
				console.error('sse error', error);
			} else {
				eventSource.close();
			}
		};
		eventSource.onmessage = (message) => {
			const data = isJson(message.data) ? JSON.parse(message.data): null;

			if (data && data.type === SSE_MESSAGE_TYPES.MESSAGE && data.data && data.dataType) {
                DebugLogger.info(`AngularJs SSE ${data.dataType} - message received`, data.data);
				dispatchEvent(data);
			} else if (data && data.type === SSE_MESSAGE_TYPES.PING) {
                DebugLogger.info(`AngularJs SSE - Ping received`);
			}
		};
	}

	this.connect = connect;

	function isJson(str) {
		try {
			JSON.parse(str);
		} catch (e) {
			return false;
		}

		return true;
	}

	function dispatchEvent(data) {
		const event = new CustomEvent(data.dataType, {detail: data.data});
		window.dispatchEvent(event);
	}

    this.$get = /* @ngInject */ function () {
        return {
            IDS
        }
    }



}
